import {ApiError} from '@legit.health/backend-client';
import {SimpleCarousel} from '@legit.health/ui';
import CloseIcon from '@mui/icons-material/Close';
import {
  Alert,
  Typography,
  Dialog,
  DialogActions,
  Button,
  DialogContent,
  IconButton,
  DialogTitle
} from '@mui/material';
import {TFunction} from 'i18next';
import {UseFormReturn} from 'react-hook-form';
import FormValues from '../../interfaces/FormValues';
import ImageErrorItem from './ImageErrorItem';

export default function ErrorDialog({
  apiError,
  closeDialog,
  form,
  t,
  shouldShowDialog
}: {
  apiError: ApiError | null;
  t: TFunction;
  form: UseFormReturn<FormValues>;
  closeDialog: () => void;
  shouldShowDialog: 0 | 1 | 2;
}) {
  return (
    <Dialog onClose={closeDialog} open={shouldShowDialog > 0} data-testid="imageErrorDialog">
      <DialogTitle sx={{m: 0, p: 2}}>
        <Typography variant="h3">Error</Typography>
        <IconButton
          aria-label="close"
          onClick={closeDialog}
          data-testid="closeImageErrorDialog"
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: 'grey.500'
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {shouldShowDialog === 1 && (
          <SimpleCarousel
            contentNodes={apiError?.content.data?.map(
              (error: {name: string; pass: boolean; position: number}) => (
                <ImageErrorItem
                  key={error.position}
                  error={error}
                  t={t}
                  imageValue={form.getValues().images[error.position]}
                />
              )
            )}
          />
        )}
        {shouldShowDialog === 2 && (
          <Alert severity="error">{t('app:diagnosticReportApiError')}</Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={closeDialog}>{t('app:close').toUpperCase()}</Button>
      </DialogActions>
    </Dialog>
  );
}
